export const announcementsList = [
    {
        id: 1,
        title: "2024-2025 Güz Dönemi Üye Alımları Başladı!",
        date: "20 Eylül 2024",
        summary: "Yeni dönemde ailemize katılmak isteyen arkadaşlarımız için başvurular açılmıştır."
    },
    {
        id: 2,
        title: "Haftalık Olağan Toplantı Duyurusu",
        date: "Her Çarşamba, 17:30",
        summary: "Topluluk odamızda gerçekleştireceğimiz haftalık toplantımıza tüm üyelerimiz davetlidir."
    },
    {
        id: 3,
        title: "Rehberlik Semineri: Doç. Dr. Meltem Altınay Özdemir",
        date: "15 Ekim 2024",
        summary: "Bölüm başkanımızın katılımıyla gerçekleşecek seminerimiz AKM B Salonu'nda."
    },
    {
        id: 4,
        title: "Genel Kurul Toplantısı",
        date: "1 Kasım 2024",
        summary: "Yönetim kurulu seçimi ve yeni dönem planlaması için toplanıyoruz."
    }
];
